module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/surgicals/img02-7105264a77140ce6773b6e583cf1291f.png";